
    import ResumeWriteMixins from '@/components/ResumeWriting/ResumeWriteMixins';

    export default {
        name: 'ResumeWriteMrec',

        mixins: [ResumeWriteMixins],

        data() {
            return {
                showPromptModal: false,
                topResumePrompt: {
                    component_name: 'TopResumePrompt',
                    title: 'Resumes',
                    code: 'topresume_prompt_more_info',
                    layout: 'lg',
                    page_referral_element: 'job_view',
                    site_position: 'job_view',
                },
            };
        },

        methods: {
            openPromptModal() {
                this.promptEvent('cta_click', 'topresume_ad_unit');
                this.showPromptModal = true;
            },

            closePromptModal() {
                this.showPromptModal = false;
            },

        },
    };
